import JChartBarNormal from './Control_Charts'
export { JChartBarNormal }
export default JChartBarNormal